import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import api from '../services/api';

export const useUser = () => {
    return useQuery({
        queryKey: ['user'],
        queryFn: api.user,
        retry: false,
        staleTime: 5 * 60 * 1000,
    });
};

export const useLogin = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (credentials) => api.login(credentials),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['user'] });
        },
    });
};

export const useRegister = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => api.register(data),
        onSuccess: async () => {
            // New API auto-logs in after registration
            await queryClient.invalidateQueries({ queryKey: ['user'] });
        },
    });
};

export const useLogout = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: () => api.logout(),
        onSettled: () => {
            queryClient.clear();
            navigate('/login', { replace: true });
        },
    });
};

export const useForgotPassword = () => {
    return useMutation({
        mutationFn: (email) => api.forgotPassword(email),
    });
};

export const useResetPassword = () => {
    return useMutation({
        mutationFn: (data) => api.resetPassword(data),
    });
};

export const useResendVerification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => api.resendVerificationEmail(),
        onSuccess: async (data) => {
            if (data?.status === 'already-verified') {
                await queryClient.invalidateQueries({ queryKey: ['user'] });
            }
        },
    });
};
